import type { SvgIconProps } from 'types/icon';
import Check from '@mui/icons-material/Check';
import CheckOutlined from '@mui/icons-material/CheckOutlined';

export const CheckIcon = ({ color = 'inherit', ...props }: SvgIconProps) => (
  <Check color={color} {...props} />
);

export const CheckOutlinedIcon = ({
  color = 'inherit',
  ...props
}: SvgIconProps) => <CheckOutlined color={color} {...props} />;
